// extracted by mini-css-extract-plugin
export var filterIncDec = "_4y-0";
export var leftBorder = "_4y-1";
export var rightBorder = "_4y-2";
export var stringInput = "_4y-3";